import { defineMessages } from 'react-intl';

const translations = {
  breadcrumbs: {
    orders: {
      id: 'pages.orderView.breadcrumbs.orders',
      defaultMessage: 'Orders',
      description: 'label of the breadcrumb orders on the order view page',
    },
  },
  subNavigation: {
    details: {
      id: 'pages.orderView.subNavigation.details',
      defaultMessage: 'Details',
      description: 'label of the details tab on the order view page',
    },
    items: {
      id: 'pages.orderView.subNavigation.items',
      defaultMessage: 'Items',
      description: 'label of the items tab on the order view page',
    },
    logs: {
      id: 'pages.orderView.subNavigation.logs',
      defaultMessage: 'Logs',
      description: 'label of the logs tab on the order view page',
    },
    communication: {
      id: 'pages.orderView.subNavigation.communication',
      defaultMessage: 'Communication',
      description: 'label of the communication tab on the order view page',
    },
  },
  primaryAction: {
    label: {
      id: 'pages.orderView.primaryAction.label',
      defaultMessage: 'Edit',
      description: 'label of the primary action on the order view page',
    },
  },
  secondaryActions: {
    allocateOrder: {
      id: 'pages.orderView.secondaryActions.allocateOrder',
      defaultMessage: 'Allocate order',
      description: 'label of the secondary action allocate order on the order view page',
    },
    cancelOrder: {
      id: 'actions.cancelOrder',
      defaultMessage: 'Cancel order',
      description: 'label of the secondary action cancel order on the order view page',
    },
    startOrderFulfilment: {
      id: 'pages.orderView.secondaryActions.startOrderFulfilment',
      defaultMessage: 'Start fulfilment',
      description: 'label of the secondary action start order fulfilment on the order view page',
    },
    confirmOrder: {
      id: 'pages.orderView.secondaryActions.confirmOrder',
      defaultMessage: 'Confirm order',
      description: 'label of the secondary action confirm order on the order view page',
    },
    triggerDataFlow: {
      id: 'pages.orderView.secondaryActions.triggerDataFlow',
      defaultMessage: 'Trigger dataflow',
      description: 'label of the secondary action trigger dataflow on the order view page',
    },
    acceptOrder: {
      id: 'pages.orderView.secondaryActions.acceptOrder',
      defaultMessage: 'Accept order',
      description: 'label of the secondary action accept order on the order view page',
    },
    deleteOrder: {
      id: 'pages.orderView.secondaryActions.deleteOrder',
      defaultMessage: 'Delete',
      description: 'label of the secondary action delete order on the order view page',
    },
    startCheckout: {
      id: 'pages.orderView.secondaryActions.startCheckout',
      defaultMessage: 'Start checkout',
      description: 'label of the secondary action start checkout on the order view page',
    },
  },
  confirmDeleteOrder: {
    title: {
      id: 'confirmDeleteOrder.title',
      defaultMessage: 'Delete order',
      description: 'Delete order confirm dialog title',
    },
    description: {
      id: 'confirmDeleteOrder.description',
      defaultMessage: 'Are you sure you would like to delete this order?',
      description: 'Delete order confirm dialog description',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Delete order confirm dialog cancel button label',
      },
      delete: {
        id: 'actions.delete',
        defaultMessage: 'Delete',
        description: 'Delete order confirm dialog delete button label',
      },
    },
  },
  sessionDialog: {
    title: {
      id: 'pages.orderView.sessionDialog.title',
      defaultMessage: 'Checkout session started',
      description: 'Checkout session started dialog title',
    },
    fields: {
      sessionUrl: {
        label: {
          id: 'pages.orderView.sessionDialog.fields.sessionUrl.label',
          defaultMessage: 'Session url',
          description: 'Checkout session started dialog field session url label',
        },
        tooltip: {
          copy: {
            id: 'pages.orderView.sessionDialog.fields.sessionUrl.tooltip.copy',
            defaultMessage: 'Copy',
            description: 'Checkout session started dialog field session url tooltip',
          },
          copied: {
            id: 'pages.orderView.sessionDialog.fields.sessionUrl.tooltip.copied',
            defaultMessage: 'Copied session url',
            description: 'Checkout session started dialog field session url tooltip',
          },
          email: {
            id: 'pages.orderView.sessionDialog.fields.sessionUrl.tooltip.email',
            defaultMessage: 'Email link to customer',
            description: 'Checkout session started dialog field send email button',
          },
        },
        button: {
          id: 'pages.orderView.sessionDialog.fields.sessionUrl.button',
          defaultMessage: 'Copy session url',
          description: 'Checkout session started dialog field session url button',
        },
      },
    },
    actions: {
      close: {
        id: 'actions.close',
        defaultMessage: 'Close',
        description: 'Checkout session started dialog close action',
      },
    },
  },
  feedback: {
    allocatingOrder: {
      id: 'pages.orderView.feedback.allocatingOrder',
      defaultMessage: 'Allocating order',
      description: 'Progress message of the allocate order action',
    },
    startOrderFulfilment: {
      id: 'pages.orderView.feedback.startOrderFulfilment',
      defaultMessage: 'Starting order fulfilment',
      description: 'Progress message of the start order fulfilment action',
    },
    checkoutNotStarted: {
      id: 'pages.orderView.feedback.checkoutNotStarted',
      defaultMessage: 'Checkout could not be started',
      description: 'Checkout started error message',
    },
    orderAllocated: {
      id: 'pages.orderView.feedback.orderAllocated',
      defaultMessage: 'Order allocation started',
      description: 'Order allocate success message',
    },
    orderNotAllocated: {
      id: 'pages.orderView.feedback.orderNotAllocated',
      defaultMessage: 'Order could not be allocated',
      description: 'Order allocate error message',
    },
    orderFulfilmentStarted: {
      id: 'pages.orderView.feedback.orderFulfilmentStarted',
      defaultMessage: 'Order fulfilment started',
      description: 'Order fulfilment started success message',
    },
    orderFulfilmentNotStarted: {
      id: 'pages.orderView.feedback.orderFulfilmentNotStarted',
      defaultMessage: 'Order fulfilment could not be started',
      description: 'Order fulfilment started error message',
    },
    orderConfirmed: {
      id: 'pages.orderView.feedback.orderConfirmed',
      defaultMessage: 'Order confirmed',
      description: 'Order confirm success message',
    },
    orderNotConfirmed: {
      id: 'pages.orderView.feedback.orderNotConfirmed',
      defaultMessage: 'Order could not be confirmed',
      description: 'Order confirm error message',
    },
    orderAccepted: {
      id: 'pages.orderView.feedback.orderAccepted',
      defaultMessage: 'Order accepted',
      description: 'Order accept success message',
    },
    orderNotAccepted: {
      id: 'pages.orderView.feedback.orderNotAccepted',
      defaultMessage: 'Order could not be accepted',
      description: 'Order accept error message',
    },
    orderDeleted: {
      id: 'pages.orderView.feedback.orderDeleted',
      defaultMessage: 'Order deleted',
      description: 'Order delete success message',
    },
    orderNotDeleted: {
      id: 'pages.orderView.feedback.orderNotDeleted',
      defaultMessage: 'Order could not be deleted!',
      description: 'Order delete error message',
    },
    emailSent: {
      id: 'pages.orderView.feedback.emailSent',
      defaultMessage: 'Email sent',
      description: 'Email sent success message',
    },
    emailNotSent: {
      id: 'pages.orderView.feedback.emailNotSent',
      defaultMessage: 'Email could not be sent',
      description: 'Email sent error message',
    },
    emailConceptSaved: {
      id: 'pages.orderView.feedback.emailConceptSaved',
      defaultMessage: 'Email concept saved',
      description: 'Email concept saved success message',
    },
    emailConceptNotSaved: {
      id: 'pages.orderView.feedback.emailConceptNotSaved',
      defaultMessage: 'Email concept not saved',
      description: 'Email concept saved error message',
    },
  },
};

export default defineMessages(translations);
